<template>
  <Modal ref="modal" title="Presenças alunos">
    <Tabs class="modal-container" :options="['Regulares', 'Reposição', 'Intervalo']">
      <div slot="Regulares">
        <div class="loading" v-if="loadingAlunos">
          <LoadingSpinner />
        </div>

        <Table v-else :headers="['Aluno', 'CPF', 'Ações']">
          <tr v-if="!regulares.length">
            <td colspan="3">
              <div class="force-center">
                Sem alunos regulares
              </div>
            </td>
          </tr>
          <tr v-else v-for="regular in regulares" :key="regular.id_aluno">
            <td>{{ regular.aluno.nome }}</td>
            <td>{{ utils.formatarCPF(regular.aluno.cpf) }}</td>
            <td>
              <IconButton @handle:click="presencaOpen(regular.aluno.cpf, regular.aluno.nome, 'regular')" color="primary"
                title="Registrar presença" :disabled="loadingActions">
                <Webcam :size="19" />
              </IconButton>
            </td>
          </tr>
        </Table>
      </div>

      <div slot="Reposição">
        <div class="loading" v-if="loadingAlunos">
          <LoadingSpinner />
        </div>

        <Table v-else :headers="['Aluno', 'CPF', 'Ações']">
          <tr v-if="!reposicoes.length">
            <td colspan="3">
              <div class="force-center">
                Sem alunos de reposição
              </div>
            </td>
          </tr>
          <tr v-else v-for="reposicao in reposicoes" :key="reposicao.id_aluno">
            <td>{{ reposicao.nome }}</td>
            <td>{{ utils.formatarCPF(reposicao.cpf) }}</td>
            <td>
              <IconButton @handle:click="presencaOpen(reposicao.cpf, reposicao.nome, 'reposicao')" color="primary"
                title="Registrar presença" :disabled="loadingActions">
                <Webcam :size="19" />
              </IconButton>
            </td>
          </tr>
        </Table>
      </div>

      <div slot="Intervalo">
        <div class="loading" v-if="loadingAlunos">
          <LoadingSpinner />
        </div>

        <Table v-else :headers="['Aluno', 'CPF', 'Ações']">
          <tr v-if="!intervalos.length">
            <td colspan="3">
              <div class="force-center">
                Sem intervalos
              </div>
            </td>
          </tr>
          <tr v-else v-for="intervalo in intervalos" :key="intervalo.id_aluno">
            <td>{{ intervalo.aluno.nome }}</td>
            <td>{{ utils.formatarCPF(intervalo.aluno.cpf) }}</td>
            <td>
              <IconButton @handle:click="presencaOpen(intervalo.aluno.cpf, intervalo.aluno.nome, 'intervalo')"
                color="primary" title="Registrar presença" :disabled="loadingActions">
                <Webcam :size="19" />
              </IconButton>
            </td>
          </tr>
        </Table>
      </div>
    </Tabs>

    <PhotoModal ref="photoModal" />
  </Modal>
</template>

<script>
import utils from '../../services/utils'
import Modal from 'core/Modal'
import Tabs from 'core/Tabs'
import LoadingSpinner from 'core/LoadingSpinner'
import Table from 'core/Table'
import IconButton from 'core/IconButton'
import Webcam from 'icons/Webcam'
import PhotoModal from './PhotoModal'

export default {
  name: 'AlunosModal',
  components: {
    Modal,
    Tabs,
    LoadingSpinner,
    Table,
    IconButton,

    Webcam,

    PhotoModal,
  },
  data() {
    return {
      utils: utils,
      turma: null,
      regulares: [],
      reposicoes: [],
      intervalos: [],
      loadingAlunos: true,
      loadingActions: false,
    }
  },
  methods: {
    async open(turma) {
      this.turma = turma

      await this.detalhes()
    },
    async detalhes() {
      this.$refs.modal.open()

      await Promise.all([
        this.getRegulares(),
        this.getReposicao(),
        this.getIntervalo(),
      ])

      this.loadingAlunos = false
    },
    async getRegulares() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/alunos/paginacao/${this.turma.id_turma_teorica}`)
        .then(res => {
          const dados = res.body

          this.regulares = dados.data
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar alunos regulares!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async getReposicao() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/alunos/reposicao/paginacao/${this.turma.id_turma_teorica}`)
        .then(res => {
          const dados = res.body

          this.reposicoes = dados
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar alunos de reposição!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async getIntervalo() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/alunos/paginacao/${this.turma.id_turma_teorica}/intervalo`)
        .then(res => {
          const dados = res.body

          this.intervalos = dados
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar intervalos!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async presencaOpen(cpf, nome, type) {
      const data = {
        cpf,
        typeSend: 'aluno',
        idTurmaTeorica: this.turma.id_turma_teorica,
        type,
      }

      this.$refs.photoModal.open(nome, data)
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 60vw;

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .force-center {
    display: flex;
    justify-content: center;
  }
}
</style>
